import React from "react";
import BitacoraEnvasado from "./BitacoraEnvasado";

/**
 * BitacoraAlmacen
 * Redirige/Renderiza el módulo integral de Bitácora de Almacén y Envasado de Mezcal
 * con todas las funcionalidades de inventario a granel, fusión/extracción NOM-070,
 * traslados, dilución, bajas, muestreos y producto terminado.
 */
const BitacoraAlmacen = (props) => {
  return <BitacoraEnvasado {...props} />;
};

export default BitacoraAlmacen;